import { useState, useMemo } from "react";
import { useLocation } from "react-router-dom";
import TrackerComponent from "../../Pages/ProfileUser/JumboEmbed/OrderTracker/TrackerComponent.js";
import queryString from "query-string";
import apiRequest from "../../../utils/ApiRequest/apiRequest.js";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import { embedColorCode } from "../JUMBOform/ExternalJsonsList/JsonLists.js";

import "./OrderTrackerScript.scss";

const OrderTrackerScript = ({
  lang = null,
  brandingColor = null,
  isModal = false,
  isMobileView = false,
  isEmbedPage = null,
}) => {
  const { getLanguage, fetchOrderTrackerConsts } = useContent();
  const location = useLocation();
  const [orderTrackerColor, setOrderTrackerColor] = useState(null);
  const searchParams = queryString.parse(location.search);
  const trackerEID = searchParams.eid;
  const [hideOrderTracker, setHideOrderTracker] = useState(false);

  const getOrderTracker = async ({ trackerEID }) => {
    const parameters = {
      encryptedUId: trackerEID || "null",
    };
    const response = await apiRequest(
      "EmbedDynamics",
      "GetOrderTracker",
      parameters
    );
    if (response.status === "success") {
      if (response.data) {
        setOrderTrackerColor(
          response.data.OrderTrackerColor
            ? response.data.OrderTrackerColor
            : embedColorCode
        );
        setHideOrderTracker(!response.data.OrderTrackerActive);
      } else {
      }
    }
  };

  useMemo(() => {
    if (trackerEID !== undefined) {
      getOrderTracker({ trackerEID });
    } else {
      getOrderTracker();
    }
  }, []);

  useMemo(() => {
    if (lang) {
      fetchOrderTrackerConsts({ language: lang });
    }
  }, [lang]);

  return (
    <div
      className={`order-tracker-script ${isModal ? "order-modal" : ""} ${
        isMobileView ? "mobileView" : ""
      }`}
    >
      <TrackerComponent
        brandingColorExternal={
          brandingColor ? brandingColor : orderTrackerColor
        }
        language={lang ? lang : getLanguage()}
        hideTracker={isEmbedPage ? false : hideOrderTracker}
      />
    </div>
  );
};

export default OrderTrackerScript;
